// React imports
import { useContext } from "react";

// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

export const StepChanger = ({
  steps,
  activeStep,
  setActiveStep,
  order,
  shipmentOne,
  shipmentTwo,
}) => {
  const { setAlertNotification } = useContext(AlertNotificationContext);

  const handleNext = () => {
    if (activeStep === 0) {
      // Check if we can proceed to Review
      if (staffItemsCheck(order.data.staff)) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      } else {
        setAlertNotification({
          message: `Please add some items to continue`,
          severity: "warning",
        });
      }
    } else if (activeStep === 1) {
      // Check if we can proceed to Submit
      if (staffItemsCheck(order.data.staff)) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      } else {
        setAlertNotification({
          message: `Please add some items to continue`,
          severity: "warning",
        });
      }
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  // Check if the order has any items
  const staffItemsCheck = (staff) => {
    let pass = true;
    staff.map((person) => {
      if (person.numberOfLines < 1) pass = false;
    });
    return pass;
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "row", pt: 2, pb: 1 }}>
      {/* {activeStep <= 2 && ( */}
      {activeStep <= 3 && (
        <Button
          color="inherit"
          disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ mr: 1 }}
        >
          Back
        </Button>
      )}
      <Box sx={{ flex: "1 1 auto" }} />
      {activeStep <= 1 && (
        <Button onClick={handleNext} disabled={!order.data.order.no}>
          {activeStep === steps.length - 1 ? "Submit Order" : "Next"}
        </Button>
      )}
    </Box>
  );
};
